import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useAuthorized, useCianAuthorized, useIsMortgageRedirectEnabled } from '../../../../hooks/useAuthorized';
import { selectActionUrl } from '../../../../selectors/landing';
import { EFillApplicationStickyButtonType } from '../types';

export const useFillApplicationButtonClick = (
  analyticEventKey: EFillApplicationStickyButtonType = EFillApplicationStickyButtonType.TOP,
) => {
  const isMortgageRedirectEnabled = useIsMortgageRedirectEnabled();
  const { authorizeAndRedirect } = useAuthorized();
  const { cianAuthorizeAndRedirect } = useCianAuthorized();
  const masterButtonActionUrl = useSelector(selectActionUrl) as string;

  return useCallback(() => {
    if (isMortgageRedirectEnabled) {
      cianAuthorizeAndRedirect();
    } else {
      authorizeAndRedirect({ path: masterButtonActionUrl, analyticEventKey });
    }
  }, [
    analyticEventKey,
    masterButtonActionUrl,
    isMortgageRedirectEnabled,
    authorizeAndRedirect,
    cianAuthorizeAndRedirect,
  ]);
};
